import { render, staticRenderFns } from "./WineForm.vue?vue&type=template&id=8c4a7f92"
import script from "./WineForm.vue?vue&type=script&lang=js"
export * from "./WineForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports